import getPageName from "./getPageName";
import lazyLoadBlock from "./lazyloadBlock";
import initCasesSlider from "./sliders.js/init-cases-slider";

const cases = () => {
  const casesWrap = document.querySelector(".newCases__blocks"),
    thisUrl = getPageName();

  if (!casesWrap) {
    return;
  }

  async function parseReviewsCareer() {
    let response = await fetch(`/files/cases.json`),
      result = await response.json(),
      dataCases;

    result.some((data) => {
      if (data.url == thisUrl) {
        dataCases = data;
        return dataCases;
      } else {
        dataCases = data;
      }
    });

    createCasesCardCareer(dataCases);
  }

  function createCasesCardCareer(data) {
    let content = '';

    data.cases.forEach((item) => {
      function generContent(arr) {
        let result = "";

        arr?.forEach((el) => {
          result += `<p class="newCasesBlock__content">${el}</p>`;
        });

        return result;
      }

      content += `
             <div class="newCases__block newCasesBlock swiper-slide" data-id="${
               item.id
             }">
                 <div class="newCasesBlock__wrap">
                     <div class="newCasesBlock__left">
                         <img class="newCasesBlock__img swiper-lazy" loading="lazy" src="${
                           item.imgIndex
                             ? `/img/tgu/cases/expert-${item.imgIndex}.webp`
                             : ""
                         }" alt="">
                         <div class="swiper-lazy-preloader"></div>
                     </div>
                     <div class="newCasesBlock__right">
                         <div class="newCasesBlock__right-top">
                             <h4 class="newCasesBlock__h4">${item.name}</h4>
                             <p class="newCasesBlock__p">${item.graduate}</p>
                             <p class="newCasesBlock__p">${item.nameProgram}</p>
                         </div>

                         <div class="newCasesBlock__right-bottom">
                             ${generContent(item.content)}
                         </div>
                         <div class="newCasesBlock__openBlock openBlock">
                             <span class="openBlock__link"></span>
                             <p class="openBlock__p">Развернуть кейс</p>
                         </div>
                     </div>
                 </div>
             </div>
     `;
    });

    casesWrap.innerHTML = content;

    setTimeout(() => {
      initCasesSlider();
    }, 50);
  }

  lazyLoadBlock(parseReviewsCareer);
};

export default cases;
